import { Instance, types } from 'mobx-state-tree';

export const PostalCode = types.model('PostalCode', {
  zipCode: types.string
});
export type PostalCode = Instance<typeof PostalCode>;
